import {JSX, memo} from 'react';

interface Props {
  condition: any;
  ifComponent: JSX.Element;
  elseComponent: JSX.Element;
}

const IfElse = (props: Props) => {
  return props.condition ? props.ifComponent : props.elseComponent;
};

export default memo(IfElse);
